import React, {useEffect, useContext} from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import NestedMenuItem from "material-ui-nested-menu-item";
import Divider from '@material-ui/core/Divider';
import EditorContext from '../../modules/contexts/editor';
import { makeStyles } from "@material-ui/core";

export const useMenuClasses = makeStyles({
    paper: {
        borderRadius: 3,
        marginTop: 3,
        boxShadow: '0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%)',
    },
    list: {
        fontSize: 9,
        color: '#6a6a6a',
    }
});

export const useMenuItemClasses = makeStyles({
    root: {
        lineHeight: 1.2,
        padding: '4px 10px',
        minHeight: 'unset',
        fontSize: 14,
    }
});

const TreeContextMenu = React.forwardRef((props, ref) => {
    const { root } = props;
    const editor = useContext(EditorContext);
    const menuClasses = useMenuClasses();
    const menuItemClasses = useMenuItemClasses();

    const MenuEntry = React.forwardRef((props, ref) => {
        const { item, open } = props;
        return (
            (item.divider ? (
                <Divider/>
            ) : (item.submenu ? (
                <NestedMenuItem classes={menuItemClasses} label={item.label} parentMenuOpen={open}>
                    {item.submenu.map((subitem, i) => <MenuEntry key={i} item={subitem} open={open}/>)}
                </NestedMenuItem>
            ) : (
                <MenuItem
                    classes={menuItemClasses}
                    disabled={editor.disableContextMenu(item)}
                    onClick={(e) => editor.handleContextMenuSelect(item, e)}
                >
                    {typeof item.label === 'function' ? item.label(item) : item.label}
                </MenuItem>
            )))
        );
    });


    return (
        <Menu
            classes={menuClasses}
            open={editor.treeContextMenu.show}
            onClose={editor.closeTreeContextMenu}
            anchorReference="anchorPosition"
            anchorPosition={{ top: editor.treeContextMenu.mouseY + 8, left: 50 /* editor.treeContextMenu.mouseX - 100 */ }}
        >
            { editor.contextMenu().map((item, i) => <MenuEntry key={i} item={item} open={!!editor.treeContextMenu.show} /> )}
        </Menu>
    );
});

export default TreeContextMenu;
